module.exports = global.EventSource;



//////////////////
// WEBPACK FOOTER
// (webpack)-dev-server/~/sockjs-client/lib/transport/browser/eventsource.js
// module id = ./node_modules/webpack-dev-server/node_modules/sockjs-client/lib/transport/browser/eventsource.js
// module chunks = 3